/* eslint-disable @typescript-eslint/ban-types */
import { useEffect } from 'react';
import { SearchEngine } from '@coveo/headless';
import { searchStatus } from 'lib/utils/coveo/searchStatus';
import { urlManagerController } from 'lib/utils/coveo/urlManager';
import { useRouter } from 'next/router';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-nextjs/utils';

const useUrlManager = (engine: SearchEngine<{}>): void | undefined => {
  const router = useRouter();
  const { sitecoreContext } = useSitecoreContext();
  useEffect(() => {
    if (isEditorActive() || sitecoreContext?.pageState === 'preview') {
      return;
    }
    if (typeof window !== 'undefined') {
      const urlFragment = window.location.hash.slice(1);
      const urlManager = urlManagerController(engine, urlFragment);

      urlManager.subscribe(() => {
        const hash = `#${urlManager.state.fragment}`;
        const pageUrl = `${window.location.pathname}${hash}`;
        if (
          searchStatus.state.firstSearchExecuted ||
          window.location.pathname.indexOf('/find-trials/search-result') > -1
        ) {
          router.replace(pageUrl);
        } else {
          router.push(pageUrl);
        }
      });

      const handleUrlChange = () => {
        const newFragment = window.location.hash.slice(1);
        urlManager.synchronize(newFragment);
      };

      window.addEventListener('hashchange', handleUrlChange);

      return () => {
        window.removeEventListener('hashchange', handleUrlChange);
      };
    }
    return undefined;
  }, [engine]);
};

export default useUrlManager;
